import { SimpleGenList } from '../simpleGenList';
import { SimpleArrayList } from '../simpleArrayList';

/**
 * Electromagnetic Spectrum - Czech
 */
export class List__ElectroSpectrum__CS extends SimpleArrayList<[string, string]> {
  constructor() {
    super(
      [
        ['Rádiové vlny', '< 300 MHz'],
        ['Mikrovlny', '300 MHz – 300 GHz'],
        ['Infračervené záření', '300 GHz – 400 THz'],
        ['Viditelné světlo', '400 – 750 THz'],
        ['Ultrafialové záření', '750 THz – 30 PHz'],
        ['Rentgenové záření', '30 PHz – 30 EHz'],
        ['Gama záření', '> 30 EHz'],
      ],
      (i) => i[0],
      (i) => i[1]
    );
  }
}

/**
 * Electromagnetic Spectrum - English
 */
export class List__ElectroSpectrum__EN extends SimpleArrayList<[string, string]> {
  constructor() {
    super(
      [
        ['Radio waves', '< 300 MHz'],
        ['Microwaves', '300 MHz – 300 GHz'],
        ['Infrared', '300 GHz – 400 THz'],
        ['Visible light', '400 – 750 THz'],
        ['Ultraviolet', '750 THz – 30 PHz'],
        ['X-rays', '30 PHz – 30 EHz'],
        ['Gamma rays', '> 30 EHz'],
      ],
      (i) => i[0],
      (i) => i[1]
    );
  }
}

/**
 * Planets of Solar System - Czech
 */
export class List__Planets__CS extends SimpleGenList {
  constructor() {
    super('Merkur', 'Venuše', 'Země', 'Mars', 'Jupiter', 'Saturn', 'Uran', 'Neptun');
  }
}

/**
 * Planets of Solar System - English
 */
export class List__Planets__EN extends SimpleGenList {
  constructor() {
    super('Mercury', 'Venus', 'Earth', 'Mars', 'Jupiter', 'Saturn', 'Uran', 'Neptune');
  }
}

/**
 * Earth Layers (from center to outer atmosphere) - Czech
 */
export class List__EarthLayers__CS extends SimpleGenList {
  constructor() {
    super(
      'Vnitřní jádro',
      'Vnější jádro',
      'Zemský plášť',
      'Zemská kůra',
      'Troposféra',
      'Stratosféra',
      'Mezosféra',
      'Termosféra',
      'Exosféra'
    );
  }
}

/**
 * Earth Layers (from center to outer atmosphere) - English
 */
export class List__EarthLayers__EN extends SimpleGenList {
  constructor() {
    super(
      'Inner Core',
      'Outer Core',
      'Mantle',
      'Crust',
      'Troposphere',
      'Stratosphere',
      'Mesosphere',
      'Thermosphere',
      'Exosphere'
    );
  }
}

/**
 * Mohs Scale of Mineral Hardness - Czech
 */
export class List__MohsScale__CS extends SimpleArrayList<[string, string]> {
  constructor() {
    super(
      [
        ['1', 'Mastek'],
        ['2', 'Sádrovec'],
        ['3', 'Kalcit'],
        ['4', 'Fluorit'],
        ['5', 'Apatit'],
        ['6', 'Ortoklas'],
        ['7', 'Křemen'],
        ['8', 'Topas'],
        ['9', 'Korund'],
        ['10', 'Diamant'],
      ],
      (i) => i[0],
      (i) => i[1]
    );
  }
}

/**
 * Mohs Scale of Mineral Hardness - English
 */
export class List__MohsScale__EN extends SimpleArrayList<[string, string]> {
  constructor() {
    super(
      [
        ['1', 'Talc'],
        ['2', 'Gypsum'],
        ['3', 'Calcite'],
        ['4', 'Fluorite'],
        ['5', 'Apatite'],
        ['6', 'Orthoclase'],
        ['7', 'Quartz'],
        ['8', 'Topaz'],
        ['9', 'Corundum'],
        ['10', 'Diamond'],
      ],
      (i) => i[0],
      (i) => i[1]
    );
  }
}

/**
 * Human Digestive Path - Czech
 */
export class List__DigestivePath__CS extends SimpleGenList {
  constructor() {
    super(
      'Dutina ústní',
      'Hltan',
      'Jícen',
      'Žaludek',
      'Tenké střevo',
      'Tlusté střevo',
      'Konečník',
      'Anální otvor'
    );
  }
}

/**
 * Human Digestive Path - English
 */
export class List__DigestivePath__EN extends SimpleGenList {
  constructor() {
    super(
      'Mouth',
      'Pharynx',
      'Esophagus',
      'Stomach',
      'Small Intestine',
      'Large Intestine',
      'Rectum',
      'Anus'
    );
  }
}

/**
 * Czech / Czechoslovak Presidents - Czech
 */
export class List__Presidents__CS extends SimpleArrayList<[string, string]> {
  constructor() {
    super(
      [
        ['Tomáš Garrigue Masaryk', '1918–1935'],
        ['Edvard Beneš', '1935–1938, 1945–1948'],
        ['Emil Hácha', '1938–1945'],
        ['Klement Gottwald', '1948–1953'],
        ['Antonín Zápotocký', '1953–1957'],
        ['Antonín Novotný', '1957–1968'],
        ['Ludvík Svoboda', '1968–1975'],
        ['Gustáv Husák', '1975–1989'],
        ['Václav Havel', '1989–2003'],
        ['Václav Klaus', '2003–2013'],
        ['Miloš Zeman', '2013–2023'],
        ['Petr Pavel', '2023–2028'],
      ],
      (i) => i[0],
      (i) => i[1]
    );
  }
}

/**
 * Czech / Czechoslovak Presidents - English
 */
export class List__Presidents__EN extends SimpleArrayList<[string, string]> {
  constructor() {
    super(
      [
        ['Tomáš Garrigue Masaryk', '1918–1935'],
        ['Edvard Beneš', '1935–1938, 1945–1948'],
        ['Emil Hácha', '1938–1945'],
        ['Klement Gottwald', '1948–1953'],
        ['Antonín Zápotocký', '1953–1957'],
        ['Antonín Novotný', '1957–1968'],
        ['Ludvík Svoboda', '1968–1975'],
        ['Gustáv Husák', '1975–1989'],
        ['Václav Havel', '1989–2003'],
        ['Václav Klaus', '2003–2013'],
        ['Miloš Zeman', '2013–2023'],
        ['Petr Pavel', '2023–present'],
      ],
      (i) => i[0],
      (i) => i[1]
    );
  }
}

/**
 * Czech Alphabet
 */
export class List__Alphabet__CS extends SimpleGenList {
  constructor() {
    super(
      'A', 'B', 'C', 'Č', 'D', 'Ď', 'E', 'F', 'G', 'H', 'CH', 'I', 'J', 'K', 'L', 'M', 'N', 'Ň', 'O', 'P', 'Q', 'R', 'Ř', 'S', 'Š', 'T', 'Ť', 'U', 'V', 'W', 'X', 'Y', 'Z', 'Ž'
    );
  }
}

/**
 * English Alphabet
 */
export class List__Alphabet__EN extends SimpleGenList {
  constructor() {
    super(
      'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
    );
  }
}

/**
 * Homologous Series of Alkanes - Czech
 */
export class List__AlkaneSeries__CS extends SimpleArrayList<[string, string]> {
  constructor() {
    super(
      [
        ['CH₄', 'Metan'],
        ['C₂H₆', 'Etan'],
        ['C₃H₈', 'Propan'],
        ['C₄H₁₀', 'Butan'],
        ['C₅H₁₂', 'Pentan'],
        ['C₆H₁₄', 'Hexan'],
        ['C₇H₁₆', 'Heptan'],
        ['C₈H₁₈', 'Oktan'],
        ['C₉H₂₀', 'Nonan'],
        ['C₁₀H₂₂', 'Dekan'],
      ],
      (i) => i[0],
      (i) => i[1]
    );
  }
}

/**
 * Homologous Series of Alkanes - English
 */
export class List__AlkaneSeries__EN extends SimpleArrayList<[string, string]> {
  constructor() {
    super(
      [
        ['CH₄', 'Methane'],
        ['C₂H₆', 'Ethane'],
        ['C₃H₈', 'Propane'],
        ['C₄H₁₀', 'Butane'],
        ['C₅H₁₂', 'Pentane'],
        ['C₆H₁₄', 'Hexane'],
        ['C₇H₁₆', 'Heptane'],
        ['C₈H₁₈', 'Octane'],
        ['C₉H₂₀', 'Nonane'],
        ['C₁₀H₂₂', 'Decane'],
      ],
      (i) => i[0],
      (i) => i[1]
    );
  }
}

/**
 * Human Life Stages - Czech
 */
export class List__HumanLifeStages__CS extends SimpleGenList {
  constructor() {
    super(
      'Prenatální vývoj',
      'Novorozenec',
      'Kojenec',
      'Batole',
      'Předškolní věk',
      'Mladší školní věk',
      'Adolescence',
      'Mladá dospělost',
      'Střední dospělost',
      'Starší dospělost',
      'Stáří'
    );
  }
}

/**
 * Human Life Stages - English
 */
export class List__HumanLifeStages__EN extends SimpleGenList {
  constructor() {
    super(
      'Prenatal development',
      'Neonatal period',
      'Infancy',
      'Toddlerhood',
      'Preschool age',
      'Middle childhood',
      'Adolescence',
      'Early adulthood',
      'Middle adulthood',
      'Late adulthood',
      'Old age (Senescence)'
    );
  }
}
